import { LegalPage } from "@/components/legal/LegalPage";
import { COMPANY } from "@/lib/company";

export default function Returns() {
  return (
    <LegalPage title="Politica de retur și dreptul de retragere" updated="iunie 2026">
      <h2>1. Dreptul legal de retragere</h2>
      <p>
        Conform O.U.G. nr. 34/2014 privind drepturile consumatorilor, aveți dreptul de a vă retrage din contract,
        fără a fi nevoie să justificați decizia, în termen de <strong>14 zile calendaristice</strong> de la data la
        care ați intrat în posesia produselor.
      </p>

      <h2>2. Cum returnați un produs</h2>
      <ul>
        <li>Ne anunțați intenția de retragere la {COMPANY.email} sau telefonic la {COMPANY.phone};</li>
        <li>Returnați produsul în termen de 14 zile de la notificare;</li>
        <li>Produsul trebuie să fie în starea în care a fost primit, împreună cu ambalajul original.</li>
      </ul>

      <h2>3. Rambursarea contravalorii</h2>
      <p>
        Vă vom rambursa toate sumele primite (inclusiv costul livrării standard), fără întârziere nejustificată și cel
        târziu în <strong>14 zile</strong> de la data la care am fost informați cu privire la decizia de retragere.
      </p>

      <h2>4. Costurile returului</h2>
      <p>
        Costul direct al returnării produselor este suportat de client, cu excepția cazurilor în care produsul livrat
        este defect sau neconform.
      </p>

      <h2>5. Produse defecte sau neconforme</h2>
      <p>
        Dacă ați primit un produs deteriorat sau greșit, vă rugăm să ne contactați. Vom înlocui produsul sau vom
        returna banii, fără costuri suplimentare pentru dumneavoastră.
      </p>

      <h2>6. Contact retururi</h2>
      <p>
        {COMPANY.legalName} · CUI {COMPANY.cui} · Nr. înreg. {COMPANY.regNo} · Tel: {COMPANY.phone} · E-mail: {COMPANY.email}
      </p>
    </LegalPage>
  );
}
